import axios from "axios";

// Use same-origin on deployed site (production or preview) so cookies work without cross-site issues (Safari ITP blocks cross-site cookies).
// Fallback to REACT_APP_BACKEND_URL only in local dev (localhost).
function resolveBackendUrl() {
    if (typeof window !== "undefined" && window.location && window.location.hostname) {
        const host = window.location.hostname;
        if (host !== "localhost" && host !== "127.0.0.1" && host !== "0.0.0.0") {
            return window.location.origin;
        }
    }
    return process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
}

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});
